import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import DeliveryDelayModal from '../../../../views/order/common/modal/DeliveryDelayModal';
import { orderActions } from '../../../../store/modules/order';
import { INVALID_REQUIRED_DELIVERY_PERIOD_MESSAGE } from '../../../../constants/service/invalidMsg/orderInvalidMsg';
import withModal from '../../../../lib/hoc/withModal';

class DeliveryDelayModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  배송지연 사유타입
       */
      reasonType: 0,
      /**
       *  발송기한
       */
      date: null,
      /**
       *  배송지연 상세사유
       */
      reason: null,
    };
  }

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'deliveryDelayModal',
    });
  };

  /**
   * 배송 지연처리하기
   */
  onSubmit = () => {
    const { form, data, deliveryDelay } = this.props;
    const { orderItemIdList } = data;
    const { reasonType, date, reason } = this.state;

    /**
     * 발송기한 체크하기
     */
    if (!date) {
      message.error(INVALID_REQUIRED_DELIVERY_PERIOD_MESSAGE);
      return;
    }

    form.validateFields((err) => {
      if (err) return;

      deliveryDelay({
        orderItemIdList,
        reasonType,
        date,
        reason,
      });

      this.closeModal();
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    const { isOpen, form } = this.props;

    return (
      <DeliveryDelayModal
        form={form}
        isOpen={isOpen}
        {...this.state}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.deliveryDelayModal.isOpen,
    data: state.order.deliveryDelayModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  deliveryDelay: orderActions.deliveryDelay,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(Form.create({})(DeliveryDelayModalContainer)));
